var map = {
	"./1.png": "aa84",
	"./checked.png": "3912",
	"./copy.png": "28b9",
	"./del.png": "08bb",
	"./layer.png": "06c7",
	"./lock.png": "5d92",
	"./share.png": "8ea3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e2e";